module.exports = __webpack_public_path__ + "img/jobs-delete.8a559c35.svg";